import axiosInstance from "auth/FetchInterceptor";
import {
  INVENTORY_TRANSACTION_HISTORY,
  INVENTORY_TRANSACTION_SUMMARY,
} from "constants/ApiConstant";

const InventoryTransactionService = {};

InventoryTransactionService.history = function (params) {
  return axiosInstance.post(INVENTORY_TRANSACTION_HISTORY, params);
};

InventoryTransactionService.summary = function (params) {
  return axiosInstance.post(INVENTORY_TRANSACTION_SUMMARY, params);
};

export default InventoryTransactionService;